import axios from '@/api'

/**
 * 全部聊天
 */
export const getChatList = (params) => {
  return axios.get('/chat/v1/list', { params }).then(res => res.data)
}

/**
 * 聊天消息列表
 */
export const getChatMessageList = (params) => {
  return axios.get('/chat/message/v1/list', { params }).then(res => res.data)
}

/**
 * 发送消息
 */
export const sendChatMessage = (data) => {
  return axios.post('/chat/message/v1/create', data).then(res => res.data)
}

/**
 * 创建私聊
 */
export const createPrivateChat = (data) => {
  return axios.post('/chat/private/v1/create', data).then(res => res.data)
}

/**
 * 标记已读
 */
export const markRead = (data) => {
  return axios.put('/chat/v1/read', data).then(res => res.data)
}

/**
 * 删除聊天
 */
export const deleteChat = (data) => {
  return axios.post('/chat/v1/delete', data).then(res => res.data)
}

/**
 * 统计未读
 */
export const countUnRead = () => {
  return axios.get('/chat/count/v1/unread').then(res => res.data)
}

/**
 * 获取存在的
 */
export const getExistChat = (params) => {
  return axios.get('/chat/v1/exist', { params }).then(res => res.data)
}

/**
 * 获取待处理的通话邀请列表
 */
export const getPendingInvites = () => {
  return axios.get('/rtc/v1/pending-invites').then(res => res.data)
}

/**
 * 取消通话邀请
 */
export const cancelCallInvite = (data) => {
  return axios.post('/rtc/v1/cancel-call', data).then(res => res.data)
}